/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import { Link } from 'react-router-dom';
import { useNewsletter } from '../../contexts/NewsletterContext';
import * as AppPropTypes from '../../lib/PropTypes';
import Label from './Label';
import NewsletterForm from './NewsletterForm';

import FacebookIcon from '../icons/Facebook';
import InstagramIcon from '../icons/Instagram';
import NewsletterIcon from '../icons/Newsletter';
import TwitterIcon from '../icons/Twitter';

import { footerLines } from '../icons/borders';

import styles from '../../../styles/partials/footer.scss';

const messages = defineMessages({
    footer_policy: {
        id: 'content.cookies.footer_policy',
        defaultMessage: 'Politique de confidentialité',
    },
});

const propTypes = {
    intl: AppPropTypes.intl.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Footer = ({ intl, className }) => {
    const { newsletter } = useNewsletter();
    const [newsletterOpen, setNewsletterOpen] = useState(newsletter || false);
    const onNewsletterClick = useCallback(() => {
        setNewsletterOpen(!newsletterOpen);
    }, [newsletterOpen, setNewsletterOpen]);
    const BorderTop = footerLines.top;
    const BorderBottom = footerLines.bottom;

    return (
        <footer
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.centered}>
                    <BorderTop className={classNames([styles.border, styles.borderTop])} />
                    <div className={styles.flex}>
                        <a
                            href={intl.formatMessage({ id: 'content.footer.facebook_url' })}
                            className={styles.network}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FacebookIcon />
                            <Label isHtml>{{ id: 'content.footer.facebook' }}</Label>
                        </a>
                        <a
                            href={intl.formatMessage({ id: 'content.footer.instagram_url' })}
                            className={styles.network}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <InstagramIcon />
                            <Label isHtml>{{ id: 'content.footer.instagram' }}</Label>
                        </a>
                        <a
                            href={intl.formatMessage({ id: 'content.footer.x_url' })}
                            className={styles.network}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <TwitterIcon />
                            <Label isHtml>{{ id: 'content.footer.x' }}</Label>
                        </a>
                        <button
                            type="button"
                            className={
                                newsletterOpen
                                    ? classNames([styles.open, styles.network])
                                    : styles.network
                            }
                            onClick={onNewsletterClick}
                        >
                            <NewsletterIcon />
                            <Label isHtml>{{ id: 'content.footer.newsletter' }}</Label>
                        </button>
                    </div>
                    <div className={styles.newsletter}>
                        {newsletterOpen ? <NewsletterForm /> : null}
                    </div>
                    <BorderBottom className={classNames([styles.border, styles.borderBottom])} />
                    <div className={styles.where}>
                        <Label isHtml>{{ id: 'content.footer.where' }}</Label>
                        <div className={styles.policy}>
                            {' - '}
                            <Link to="/politique-de-confidentialite">
                                <FormattedMessage {...messages.footer_policy} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default injectIntl(Footer);
